<!--
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-04-26 08:52:17
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-04-26 16:00:38
 * @FilePath: \sns-user-frontend\src\components\language.vue
 * @Description: 
-->
<template>
  <div class="language">
    <div class="language-tips">Select the language you'd like to experience the community interface in. This won't change the language of user-generated content.</div>
    <ul class="language-options">
      <li v-for="(item, index) in languageList" :key="index" @click="selectLanguage(index)">
        <span class="language-name">
          {{ item.name }}
        </span>
        <span class="language-select" v-if="item.active">
          <svg-icon name="icon-done"></svg-icon>
        </span>
      </li>
    </ul>
  </div>
</template>
<script setup>
  import languageList from '@/lang/languageList.json'

  import { useSystemStore } from '@/stores/system'
  import { storeToRefs } from 'pinia'

  const systemStore = useSystemStore()
  const { isWeb } = storeToRefs(systemStore)

  const { proxy } = getCurrentInstance()

  const props = defineProps({
    currentLanguage: {
      type: String,
      datault: ''
    }
  })
  
  const emit = defineEmits(['close', 'update:currentLanguage'])

  let defaultLanguage = localStorage.getItem('communityLanguage')
  if (defaultLanguage) {
    defaultLanguage = JSON.parse(defaultLanguage)
  } else {
    defaultLanguage = import.meta.env.VITE_COUNTRY === 'CHINA' ? {
      name: '简体中文',
      value: 'zh-CN'
    } : {
      name: 'English',
      value: 'en-GB'
    }
  }

  languageList.forEach(i => {
    i.active = i.name === defaultLanguage.name
  })

  const selectLanguage = (index) => {
    languageList.forEach((item) => {
      item.active = false
    })
    languageList[index].active = true
    if (!isWeb.value) {
      emit('update:currentLanguage', languageList[index].value)
      return
    }
    changeLanguage(index)
  }
  const changeLanguage = (index) => {
    let selectIndex = 0
    if (isWeb.value) {
      selectIndex = index
    } else {
      languageList.forEach((item, index) => {
        if (item.value === props.currentLanguage) {
          selectIndex = index
        }
      })
    }
    let selectedLanguage = JSON.stringify({ 
      value: languageList[selectIndex].value,
      name: languageList[selectIndex].name 
    })
    localStorage.setItem('communityLanguage', selectedLanguage)
    proxy.$i18n.locale = languageList[selectIndex].value
    emit('close')
    window.location.reload()
  }

  defineExpose({
    changeLanguage
  })
</script>
<style lang="postcss" scoped>
.language {
  .language-tips {
    font-size: 14px;
    line-height: 23px;
    color: var(--text-secondary);
    padding: 28px 48px 8px 48px;
    word-break: break-word;
  }
  .language-options {
    overflow: auto;
    height: calc(70vh - 150px);
    &::-webkit-scrollbar {
      display: none;
    }
    li{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 59px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 20px;
      }
      &:active, &:hover {
        background: var(--background-listpressed);
      }
      .language-name {
        margin-left: 48px;
        font-size: 18px;
        color: var(--text-primary);
      }
      .language-select {
        margin-right: 48px;
        .svg-icon {
          color: var(--text-primary);
        }
      }
    }
  }
}
@media (max-width: 1023px) {
  .language {
    .language-tips {
      padding: 12px 20px 12px 24px;
      font-size: 12px;
      line-height: 16px;
    }
    .language-options {
      overflow: auto;
      height: 100%;
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        height: 52px;
        .language-name {
          margin-left: 24px;
          font-size: 16px;
        }
        .language-select {
          margin-right: 20px;
        }
        &:last-child {
          margin-bottom: 92px;
        }
      }
    }
  }
}
</style>
